<template>
  <div class="">
    <div class="create-store-based-marketing-title">
      <CustomBreadcrumb/>
    </div>
    <div class="marketing-head-border">
      <div class="campaign-name">Campaign Name<span>*</span></div>
      <el-input maxlength="255" show-word-limit v-model="createForm.campaignName" @blur="blurInput($event)"/>
      <div v-if="campaignNameError" class="tips-error">Please fill in Campaign Name</div>
      <div class="marketing-cycle">Marketing Cycle<span>*</span></div>
      <el-select v-model="createForm.marketingCycle" @change="changeMarketingCycle">
        <el-option
          v-for="item in marketingCycleList"
          :key="item.label"
          :label="item.label"
          :value="item.label">
        </el-option>
      </el-select>
      <div class="type-label">Type<span>*</span></div>
      <div :class="{'type':createForm.typeList.indexOf(item.title)<0,'type-selected':createForm.typeList.indexOf(item.title)>-1}" v-for="(item,index) in typeList" :key="index" @click="changeType(item )">
        <div class="type-img"><img :src="item.img"/></div>
        <div class="type-right">
          <div class="type-title">{{item.title}}</div>
          <div class="type-subtitle">{{item.subtitle}}</div>
        </div>
      </div>
    </div>
    <div class="send-user-choice">Send User Choices<span>*</span></div>
    <div class="send-user-choice-row" v-for="(item,index) in sendUserChoiceList" :key="index">
      <el-select v-model="item.sendType" @change="changeSendType(item,index)">
        <el-option
          v-for="item in sendTypeList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-model="item.storeNumber" @change="changeStoreNumber">
        <el-option
          v-for="item in storeNumberList"
          :key="item.label"
          :label="item.label"
          :value="item.label">
        </el-option>
      </el-select>
      <el-select v-if="item.isShowStoreType" v-model="item.storeType" filterable @change="changeStoreType(item,index)">
        <el-option
          v-for="item in storeTypeList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <div v-if="item.recommendationsStore" class="recommendations-store-border" @click="gotoReport(item.recommendationsStore)">
        <div class="recommendations-store-img"><img :src="item.recommendationsStore.mainImg"/></div>
        <div class="recommendations-store-right">
          <div class="recommendations-store-tips">The store sample</div>
          <div class="recommendations-store-name">{{item.recommendationsStore.storeName}}</div>
          <div class="recommendations-store-address">{{item.recommendationsStore.storeAddress}}</div>
        </div>
      </div>
      <div v-if="index!==0" class="delete-action" @click="deleteRow(item,index)">
        <i class="el-icon-delete"></i>
      </div>
    </div>
    <div v-if="sendUserChoiceList.length <5" class="add-send-user-choice" @click="addSendUser">
      <i class="el-icon-plus"></i>
    </div>
    <div class="bottom-border">
      <div class="bottom-border-top">
        <div class="bottom-border-top-title">Total</div>
        <div class="bottom-border-top-content">
          <div class="bottom-border-top-row" v-for="(item,index) in totalStoreTypeList" :key="index">
            Send <span>{{ item.storeType }}</span><span>{{ item.storeTypeNumber }}</span> Stores.
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="bottom-border-service-fee">
        <div class="bottom-border-service-fee-title">Service fees:</div>
        <div class="bottom-border-service-fee-content">
          <div class="bottom-border-service-fee-total">Total:<span>${{ Number(serviceFee.total).toFixed(2)}}</span></div>
          <div class="bottom-border-service-fee-discount">Discount:<span>{{serviceFee.discount}}</span>OFF</div>
          <div class="bottom-border-service-fee-payable">Total payable:<span>${{ Number(serviceFee.totalPayable).toFixed(2)}}</span></div>
        </div>
      </div>
      <div class="bottom-action">
        <div class="bottom-action-next" @click="preview">Next</div>
        <div class="bottom-action-cancle" @click="cancel">Cancel</div>
      </div>
    </div>
    <el-dialog :visible.sync="previewVisibleDialog" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="preview-dialog-border">
        <div v-if="previewType ===1" class="preview-dialog-next">
          <div class="preview-dialog-tips">Confirm submission</div>
          <div class="preview-dialog-form">
            <div class="preview-dialog-row">
              <div class="preview-dialog-row-label">Campaign Name</div>
              <div class="preview-dialog-row-value">{{createForm.campaignName}}</div>
            </div>
            <div class="preview-dialog-row">
              <div class="preview-dialog-row-label">Marketing Cycle</div>
              <div class="preview-dialog-row-value">{{createForm.marketingCycle}}</div>
            </div>
            <div class="preview-dialog-row">
              <div class="preview-dialog-row-label">Type</div>
              <div class="preview-dialog-row-value">
                <div class="preview-dialog-row-value-border" v-for="(item,index) in createForm.typeList" :key="index">
                  <div class="preview-dialog-row-value-title">{{item}}</div>
                  <div class="preview-dialog-row-value-content">Send a targeted message to your contacts through {{item}}.</div>
                  <el-divider v-if="index !== createForm.typeList.length-1"></el-divider>
                </div>
              </div>
            </div>
            <!-- <div class="preview-dialog-row">
              <div class="preview-dialog-row-label">Send User Choices</div>
              <div class="preview-dialog-row-value">
                <div class="preview-dialog-row-value-border" v-for="(item,index) in sendUserChoiceList" :key="index">
                  <div class="preview-dialog-row-value-store-type" v-if="item.sendType ==='Al-Powered Shop Recommendations'"><span>{{item.sendType}}</span><span class="preview-dialog-row-value-store-number">{{item.storeNumber}}</span> </div>
                  <div class="preview-dialog-row-value-store-type" v-else><span>{{item.storeType}}</span> <span class="preview-dialog-row-value-store-number">{{item.storeNumber}}</span> </div>
                  <el-divider></el-divider>
                </div>
              </div>
            </div> -->
            <div class="preview-dialog-row">
              <div class="preview-dialog-row-label">Total</div>
              <div class="preview-dialog-row-value">
                <div class="preview-dialog-row-value-border" v-for="(item,index) in totalStoreTypeList" :key="index">
                  <div class="preview-dialog-row-value-store-type"><span>{{ item.storeType }}</span><span>{{ item.storeTypeNumber }}</span> stores</div>
                  <el-divider></el-divider>
                </div>
              </div>
            </div>
            <div class="bottom-border-service-fee">
              <div class="bottom-border-service-fee-title">Service fees:</div>
              <div class="bottom-border-service-fee-content">
                <div class="bottom-border-service-fee-total">Total:<span>${{ Number(serviceFee.total).toFixed(2)}}</span></div>
                <div class="bottom-border-service-fee-discount">Discount:<span>{{serviceFee.discount}}</span>OFF</div>
                <div class="bottom-border-service-fee-payable">Total payable:<span>${{ Number(serviceFee.totalPayable).toFixed(2)}}</span></div>
              </div>
            </div>
            <div class="bottom-action" v-loading="submitLoading">
              <div class="bottom-action-next"  @click="submit">Submit</div>
              <div class="bottom-action-cancle" @click="returnToEdit">Return To Edit</div>
            </div>
          </div>
        </div>
        <div v-if="previewType === 2" class="preview-dialog-cancle">
          <div class="preview-dialog-cancle-title">If you cancel, your entries will not be saved. Are you sure you want to cancel?</div>
          <div class="bottom-action">
            <div class="bottom-action-next" @click="confirm">Confirm</div>
            <div class="bottom-action-cancle" @click="returnToEdit">Cancle</div>
          </div>
        </div>
        <div v-if="previewType === 3" class="preview-dialog-success">
          <div class="preview-dialog-success-title">Submission Successful.</div>
          <div class="preview-dialog-success-subtitle">Please be patient, our sales team will contact you within 48 hours</div>
          <div class="bottom-action">
            <div class="bottom-action-next" @click="goBack">Back to Home</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction } from '../../api/manage'
import CustomBreadcrumb from '../components/custom-breadcrumb'
import Vue from 'vue'
export default {
  components: {
    CustomBreadcrumb
  },
  data() {
    return {
      createForm: {
        campaignName: '',
        marketingCycle: '',
        typeList: [
          'Email'
        ]
      },
      marketingCycleList: [],
      marketingCycleDataList: [], // 源数据
      campaignNameError: false,
      storeNumberDataList: [], // 源数据
      storeNumberList: [],
      maxStoreNumber: 0, // 最大店铺数量
      storeTypeList: [],
      typeList: [
        {
          img: require('@/assets/img/marketing/marketing-email.png'),
          title: 'Email',
          subtitle: 'Send a targeted message to your contacts through email.'
        },
        {
          img: require('@/assets/img/marketing/marketing-sms.png'),
          title: 'SMS',
          subtitle: 'Send a targeted message to your contacts through SMS.'
        }
      ],
      isUpdateCampaignName: false,
      sendUserChoiceList: [],
      sendTypeList: [
        'Al-Powered Shop Recommendations',
        'Manually Choose Store Types'
      ],
      serviceFee: {
        total: 0,
        discount: '0%',
        totalPayable: 0
      },
      totalStoreNumber: 0, // 总店铺数
      previewDate: '',
      totalStoreTypeList: [],
      previewVisibleDialog: false, // 预览弹框显隐
      previewType: null,
      submitLoading: false
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  created() {
    this.getMarketingCycle()
    this.getMaxStoreNumber()
    this.getStoreTypeList()
    this.createCampaignName()
    this.getRecommendationsStore(this.sendUserChoiceList[0])
  },
  methods: {
    handleBeforeUnload(event) {
      event.preventDefault()
      event.returnValue = '' // Chrome requires setting returnValue to a non-empty string
      // 自定义处理逻辑
      if (this.$route.path === '/menu/create-store-based-marketing') {
        // 当前为首页时显示提示消息
        event.returnValue = '确认离开此网站？'
      } else {
        // 非首页则不显示任何提示消息
        event.returnValue = null
      }
    },
    goBack() {
      Vue.prototype.isCreateMarketing = false
      // 成功跳转回 列表
      this.$router.push({path: '/menu/store-based-marketing'})
    },
    /**
     * 提交方法
     */
    submit() {
      if (this.submitLoading) {
        return
      }
      this.submitLoading = true
      // 组装参数
      const params = {}
      params.campaignName = this.createForm.campaignName
      params.marketingCycle = this.createForm.marketingCycle
      params.totalAmount = this.serviceFee.total
      params.discount = this.serviceFee.discount
      params.totalPayable = this.serviceFee.totalPayable
      // 组装type Email还是SMS
      if (this.createForm.typeList.length > 1) {
        params.marketingType = 3
      } else {
        if (this.createForm.typeList.indexOf('Email') > -1) {
          params.marketingType = 1
        }
        if (this.createForm.typeList.indexOf('SMS') > -1) {
          params.marketingType = 2
        }
      }
      // 组装sendUserChoice
      let marketingStoreTypeList = []
      for (var index = 0; index < this.sendUserChoiceList.length; index++) {
        const sendUserChoiceObject = this.sendUserChoiceList[index]
        const marketingStoreTypeObject = {}
        const selectedStoreNumber = this.storeNumberDataList.filter(e => e.text === sendUserChoiceObject.storeNumber)
        if (selectedStoreNumber && selectedStoreNumber.length > 0) {
          marketingStoreTypeObject.count = Number(selectedStoreNumber[0].value)
        }
        // 自动的
        if (sendUserChoiceObject.sendType === 'Al-Powered Shop Recommendations') {
          marketingStoreTypeObject.choiceType = sendUserChoiceObject.sendType
          marketingStoreTypeObject.storeType = sendUserChoiceObject.sendType
        } else {
          marketingStoreTypeObject.choiceType = sendUserChoiceObject.sendType
          marketingStoreTypeObject.storeType = sendUserChoiceObject.storeType
        }
        marketingStoreTypeList.push(marketingStoreTypeObject)
      }
      params.marketingStoreTypeList = marketingStoreTypeList

      postAction('/marketing/activity/api/v0.2/save', params).then(response => {
        if (response.success) {
          this.submitLoading = false
          this.$message.success(response.result)
          this.previewType = 3
        } else {
          this.submitLoading = false
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 返回编辑
     */
    returnToEdit() {
      this.previewVisibleDialog = false
    },
    /**
     * 预览
     */
    preview() {
      if (this.campaignNameError) {
        return
      }
      // 先判断是否 超出了最大店铺数的限制
      if (this.maxStoreNumber < this.totalStoreNumber) {
        this.$message.error('The maximum allowed number of stores for a single send is ' + this.maxStoreNumber + '. Please adjust accordingly.')
        return
      }
      this.previewVisibleDialog = true
      this.previewType = 1
    },
    confirm() {
      Vue.prototype.isCreateMarketing = false
      // 确定离开页面
      this.$router.push({path: '/menu/store-based-marketing'})
    },
    cancel() {
      this.previewVisibleDialog = true
      this.previewType = 2
    },
    /**
     * 计算底部Total
     */
    calculateTotal() {
      let totalStoreTypeListTemp = []
      const newArr = this.arrGroup(this.sendUserChoiceList, (item) => item.storeType)
      // 增加记录总的店铺数
      let totalStoreNumberTemp = 0
      for (var index = 0; index < newArr.length; index++) {
        let storeTypeList = newArr[index]
        // 这里面每个是一个类型
        const params = {}
        let storeTypeNumber = 0
        // 组装
        for (var storeTypeIndex = 0; storeTypeIndex < storeTypeList.length; storeTypeIndex++) {
          let storeTypeObject = storeTypeList[storeTypeIndex]
          if (storeTypeObject.sendType === 'Al-Powered Shop Recommendations') {
            params.storeType = 'Al-Powered Shop Recommendations'
          } else {
            params.storeType = storeTypeObject.storeType
          }
          const selectedStoreNumber = this.storeNumberDataList.filter(e => e.text === storeTypeObject.storeNumber)
          if (selectedStoreNumber && selectedStoreNumber.length > 0) {
            storeTypeNumber = storeTypeNumber + Number(selectedStoreNumber[0].value)
          }
        }
        params.storeTypeNumber = storeTypeNumber
        totalStoreNumberTemp = totalStoreNumberTemp + storeTypeNumber
        totalStoreTypeListTemp.push(params)
      }
      this.totalStoreTypeList = totalStoreTypeListTemp
      this.totalStoreNumber = totalStoreNumberTemp
    },
    arrGroup(arr, fn) {
      const obj = {}
      arr.forEach(item => {
        const key = JSON.stringify(fn(item))
        obj[key] = obj[key] || []
        obj[key].push(item)
      })
      return Object.keys(obj).map(k => {
        return obj[k]
      })
    },
    /**
     * 计算
     */
    calculatePrice() {
      const params = {}
      // 找到选中的周期
      const selectedMarketingCycle = this.marketingCycleDataList.filter(e => e.text === this.createForm.marketingCycle)
      if (selectedMarketingCycle && selectedMarketingCycle.length > 0) {
        params.marketingCycle = Number(selectedMarketingCycle[0].value)
        // 处理日期的起始时间
        this.previewDate = this.getTime() + '-' + this.getTime(3)
      }
      // 获取店铺数量
      let storeNum = 0
      for (var index = 0; index < this.sendUserChoiceList.length; index++) {
        const sendUserChoiceObject = this.sendUserChoiceList[index]
        // 找到对应value值
        const selectedStoreNumber = this.storeNumberDataList.filter(e => e.text === sendUserChoiceObject.storeNumber)
        if (selectedStoreNumber && selectedStoreNumber.length > 0) {
          storeNum = storeNum + Number(selectedStoreNumber[0].value)
        }
      }
      params.storeCount = storeNum
      postAction('/marketing/activity/api/v0.2/service-fee', params).then(response => {
        if (response.success) {
          if (response.result) {
            this.serviceFee = response.result
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 切换发送店铺数量
     */
    changeStoreNumber() {
      this.calculatePrice()
      this.calculateTotal()
    },
    /**
     * 切换发送周期计算价格
     */
    changeMarketingCycle() {
      this.calculatePrice()
    },
    /**
     * 发送类型为手动的时候
     */
    changeStoreType(item, index) {
      this.getRecommendationsStore(item)
      this.calculateTotal()
    },
    /**
     * 选择发送类型是 AI还是手动
     */
    changeSendType(item, index) {
      // 选择手动就要给storeType赋值
      if (item.sendType === 'Manually Choose Store Types') {
        item.isShowStoreType = true
        item.storeType = this.storeTypeList[0]
      } else {
        item.isShowStoreType = false
        item.storeType = ''
      }
      // 调用接口获取推荐店铺
      this.getRecommendationsStore(item)
      this.calculateTotal()
    },
    /**
     * 获取推荐店铺
     */
    getRecommendationsStore(item) {
      const params = {}
      // 先把该行的店铺推荐设置为null 重新获取
      item.recommendationsStore = null
      let recommendationsStoreIdList = []
      // 获取已经返回的推荐店铺
      for (var index = 0; index < this.sendUserChoiceList.length; index++) {
        const sendUserChoiceObject = this.sendUserChoiceList[index]
        // 如果有值的情况下去请求
        if (sendUserChoiceObject.recommendationsStore) {
          recommendationsStoreIdList.push(sendUserChoiceObject.recommendationsStore.storeId)
        }
      }
      // 如果不是AI就加类型
      if (item.isShowStoreType) {
        params.storeType = item.storeType
      }
      if (recommendationsStoreIdList.length > 0) {
        params.exclusionStoreIds = recommendationsStoreIdList
      }
      postAction('/marketing/activity/api/v0.2/suggestion-store', params).then(response => {
        if (response.success) {
          if (response.result) {
            item.recommendationsStore = response.result
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    addSendUser() {
      // 添加一条sendUser
      const sendUserObject = {
        sendType: 'Al-Powered Shop Recommendations',
        storeNumber: this.storeNumberList[0].label,
        storeType: '',
        isShowStoreType: false,
        recommendationsStore: null
      }
      this.getRecommendationsStore(sendUserObject)
      this.sendUserChoiceList.push(sendUserObject)
      // 添加后计算价格
      this.calculatePrice()
      this.calculateTotal()
    },
    deleteRow(item, index) {
      this.sendUserChoiceList.splice(index, 1)
      // 删除后计算价格
      this.calculatePrice()
      this.calculateTotal()
    },
    blurInput(event) {
      this.createForm.campaignName = event.target.value.trim()
      if (this.createForm.campaignName) {
        this.campaignNameError = false
      } else {
        this.campaignNameError = true
      }
      // 如果值已经被手动改过了就不走任何逻辑了
      if (this.isUpdateCampaignName) {
        return
      }
      // 如果没有被手动改过了就要判断和老数据是否一样
      if (this.oldCampaignName !== event.target.value) {
        this.isUpdateCampaignName = true
      }
    },
    /**
     * 选中或取消type的时候
     */
    changeType(item) {
      // 判断是否已经选中了，如果没有选中的直接选中
      const index = this.createForm.typeList.indexOf(item.title)
      if (index < 0) {
        this.createForm.typeList.push(item.title)
      } else {
        // 如果选中了那就要判断，当前已选的集合里面是不是只有一个了，如果只有一个，那么就不能取消选中
        if (this.createForm.typeList.length === 1) {
          return
        }
        this.createForm.typeList = this.createForm.typeList.filter(e => e !== item.title)
      }
      this.createCampaignName()
    },
    /**
     * 获取店铺类型集合列表
     */
    getStoreTypeList() {
      getAction('/marketing/activity/api/v0.2/store-types').then(response => {
        if (response.success) {
          if (response.result) {
            this.storeTypeList = response.result
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getMaxStoreNumber() {
      getAction('/sys/dict/getDictItems/max_store_type').then(response => {
        if (response.success) {
          if (response.result) {
            this.maxStoreNumber = Number(response.result[0].value)
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getStoreNumber() {
      getAction('/sys/dict/getDictItems/manually_choose_store_types').then(response => {
        if (response.success) {
          let storeNumberOptions = []
          this.storeNumberDataList = response.result
          for (var index = 0; index < response.result.length; index++) {
            const storeNumberOption = {}
            const storeNumberObject = response.result[index]
            storeNumberOption.label = storeNumberObject.text
            storeNumberOptions.push(storeNumberOption)
          }
          this.storeNumberList = storeNumberOptions
          this.sendUserChoiceList.push({
            sendType: 'Al-Powered Shop Recommendations',
            storeNumber: this.storeNumberList[0].label,
            storeType: '',
            isShowStoreType: false,
            recommendationsStore: null
          })
          this.getRecommendationsStore(this.sendUserChoiceList[0])
          // 给中默认值后，计算价格
          this.calculatePrice()
          // 计算total
          this.calculateTotal()
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getMarketingCycle() {
      getAction('/sys/dict/getDictItems/marketing_cycle').then(response => {
        if (response.success) {
          if (response.result) {
            let marketingCycleOptions = []
            this.marketingCycleDataList = response.result
            for (var index = 0; index < response.result.length; index++) {
              const marketingCycleOption = {}
              const marketingCycleObject = response.result[index]
              marketingCycleOption.label = marketingCycleObject.text
              marketingCycleOptions.push(marketingCycleOption)
            }
            this.marketingCycleList = marketingCycleOptions
            this.createForm.marketingCycle = marketingCycleOptions[0].label
            this.getStoreNumber()
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    /**
     * 自动生成 CampaignName
     */
    createCampaignName() {
      // 如果手动修改过，就不处理了
      if (this.isUpdateCampaignName) {
        return
      }
      // 获取brandName
      const brandName = this.$route.query.brandName
      if (brandName === undefined || !brandName) {
        this.$message.warning('该用户没有绑定品牌')
        Vue.prototype.isCreateMarketing = false
        setTimeout(() => {
          this.$router.push({path: '/menu/store-based-marketing'})
        }, 1000)
        return
      }
      let typeStr = ''
      // 获取选中的Type
      for (var index = 0; index < this.createForm.typeList.length; index++) {
        if (index > 0) {
          typeStr = typeStr + ' & '
        }
        typeStr = typeStr + this.createForm.typeList[index]
      }
      // 获取时间
      const time = this.getTime()
      const campaignName = brandName + ' ' + typeStr + ' Campaign ' + time
      this.createForm.campaignName = campaignName
      this.oldCampaignName = campaignName
    },
    getTime(intervalMonth) {
      var currentTime = new Date()
      if (intervalMonth) {
        currentTime.setMonth(currentTime.getMonth() + intervalMonth)
      }
      var year = currentTime.getFullYear()
      var month = currentTime.getMonth() + 1 // 注意要加上1，因为月份从0开始计算
      var day = currentTime.getDate()
      var hours = currentTime.getHours()
      var minutes = currentTime.getMinutes()
      return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes)
    },
    gotoReport(recommendationsStore) {
      var encrypt = btoa(recommendationsStore.storeId)
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${recommendationsStore.userId}&storeId=${encrypt}`)
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.create-store-based-marketing-title {
  font-size: 14px;
  font-weight: 600;
  color: #262B2F;
  margin: 10px 0px 20px 0px !important;
}
.marketing-head-border{
  width: 486px;
  .marketing-cycle,.type-label,.campaign-name{
    margin: 20px 0px 10px 0px;
    font-family: Satoshi-Medium !important;
    color: #262B2F;
    span{
      color: #FB541C;
      margin-left: 5px;
    }
  }
  .type,.type-selected{
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid #707070;
    padding: 20px;
    margin-bottom: 10px;
    .type-img{
      width: 20px;
      height: 17px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .type-right{
      margin-left: 20px;
      .type-title{
        font-family: Satoshi-Medium !important;
        color: #262613;
      }
      .type-subtitle{
        margin-top: 10px;
      }
    }
  }
  .type-selected{
    border: 1px solid #F3E93D;
    background-color: #FFFCD1;
  }
  /deep/ .el-select{
    width: 100%;
  }
}
.tips-error{
  color: #FB541C;
}
/deep/ .el-input__inner{
  font-family: Satoshi-Medium !important;
  color: #262613;
}
.send-user-choice{
  margin: 20px 0px 10px 0px;
  font-family: Satoshi-Medium !important;
  color: #262B2F;
  span{
    color: #FB541C;
    margin-left: 5px;
  }
}
.send-user-choice-row{
  display: flex;
  align-items: center;
  margin:20px 0px;
  .el-select:nth-child(1){
    width: 26%;
    max-width: 486px;
  }
  .el-select:nth-child(2){
    width: 13%;
    max-width: 278px;
    margin-left: 10px;
  }
  .el-select:nth-child(3){
    width: 20%;
    max-width: 278px;
    margin-left: 10px;
  }
}
.recommendations-store-border{
  width: 360px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background-color: #F8F8F8;
  border: 1px solid #E1E1E1;
  cursor: pointer;
  .recommendations-store-img{
    width: 85px;
    height: 64px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .recommendations-store-right{
    width: calc(100% - 100px);
    margin-left: 10px;
    .recommendations-store-tips,.recommendations-store-name,.recommendations-store-address{
      color: #000000;
      margin:3px 0px;
      overflow: hidden;
      white-space: nowrap; /* 防止文本换行 */
      text-overflow: ellipsis; /* 在文本溢出时显示省略号 */
    }
    .recommendations-store-name{
      font-family: Satoshi-Medium !important;
    }
  }
}
.delete-action,.add-send-user-choice{
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  border: 1px solid #707070;
  background: #000000;
  cursor: pointer;
  i{
    color: #FFFFFF;
    font-size: 20px;
  }
}
.add-send-user-choice{
  margin-left: 0px;
}
.bottom-border{
  margin-top: 30px;
  border: 1px solid #E1E1E1;
  background: #F8F8F8;
  padding: 25px 20px 0px 20px;
  .bottom-border-top{
    display: flex;
    .bottom-border-top-content{
      margin-left: 20px;
      .bottom-border-top-row{
        margin-bottom: 5px;
        color: #000000;
        span:nth-child(1){
          font-family: Satoshi-Medium !important;
        }
        span:nth-child(2){
          font-family: Satoshi-Medium !important;
          margin-left: 10px;
        }
      }
    }
  }
}
.bottom-border-top-title,.bottom-border-service-fee-title{
  font-family: Satoshi-Medium !important;
  color: #000000;
}
.bottom-border-service-fee-content{
  margin: 15px 0px 0px 50px;
  .bottom-border-service-fee-total,.bottom-border-service-fee-discount,.bottom-border-service-fee-payable{
    color: #000000;
    margin-bottom: 10px;
    span{
      margin-left: 10px;
      font-family: Satoshi-Bold !important;
    }
  }
  .bottom-border-service-fee-total,.bottom-border-service-fee-discount{
    span{
      font-family: Satoshi-Medium !important;
    }
  }
}
.el-divider--horizontal{
  margin:20px 0px
}
.bottom-action{
  display: flex;
  align-items: center;
  padding: 10px 0px 30px 0px;
  .bottom-action-next,.bottom-action-cancle{
    width: 100px;
    height: 30px;
    border-radius: 3px;
    border: 1px solid #707070;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: Satoshi-Medium !important;
    color: #FFFFFF;
    background: #000000;
  }
  .bottom-action-cancle{
    margin-left: 20px;
    background: #FFFFFF;
    color: #000000;
  }
}
/deep/ .el-dialog{
  width: 640px;
}
.preview-dialog-border{
  padding: 30px;
}
.preview-dialog-tips{
  font-family: Satoshi-Bold !important;
  color: #262B2F;
}
.preview-dialog-row{
  display: flex;
  color: #000000;
  margin:20px 0px;
  .preview-dialog-row-label{
    width: 107px;
    font-family: Satoshi-Medium !important;
    text-align: right;
  }
  .preview-dialog-row-value{
    width: calc(100% - 153px);
    margin-left: 33px;
    .preview-dialog-row-value-border{
      .preview-dialog-row-value-title,.preview-dialog-row-value-content{
        font-family: Satoshi-Bold !important;
        color: #000000;
      }
      .preview-dialog-row-value-content{
        font-family: Satoshi-Regular !important;
        margin-top: 10px;
      }
    }
  }
}
.preview-dialog-row-value-store-type,.preview-dialog-row-value-store-number{
  color:#000000;
  display: flex;
  font-family: Satoshi-Medium !important;
  span:nth-child(1){
    width: 260px;
    font-family: Satoshi-Medium !important;
  }
  span:nth-child(2){
    font-family: Satoshi-Medium !important;
    margin-right: 3px;
  }
}
.preview-dialog-next,.preview-dialog-cancle,.preview-dialog-success{
  .bottom-action{
    width: 100%;
    justify-content: center;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 0px;
  }
}
.preview-dialog-cancle-title{
  text-align: center;
  font-family: Satoshi-Medium !important;
  color:#000000;
  margin-bottom: 20px;
}
.preview-dialog-success-title{
  text-align: center;
  font-family: Satoshi-bold !important;
  font-size: 18px;
  color:#262B2F;
}
.preview-dialog-success-subtitle{
  text-align: center;
  font-family: Satoshi-Medium !important;
  color: #000000;
  margin: 20px 0px 45px 0px
}
</style>



// WEBPACK FOOTER //
// src/pages/store-based-marketing/store-based-marketing-create.vue